import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
          <Col style={{alignItems: 'flex-end'}}>
	  <Row>
Полное наименование организации: Общество с ограниченной ответственностью "Спутник"
	  </Row>
	  <Row>
ИНН 3808283228 КПП 380801001 ОГРН 1233800013468
	  </Row>
	  <Row>
Адрес: Россия, Иркутская область, г. Иркутск, ул. Киевская, 24, ОФИС 406/3
	  </Row>
	  <Row>
Сведения об основном виде деятельности: Разработка компьютерного программного обеспечения (ОКВЭД 62.01)
	  </Row>
	  <Row>
Коды видов деятельности в области информационных технологий в соответствии с перечнем видов деятельности в области информационных технологий, утвержденного приказом Минцифры России от 11.05.2023 № 449: 1.01,1.02, 1.05, 1.06, 3.01, 4.01, 5.01, 11.01,11.02,28.01, 28.02.
	  </Row>

          </Col>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
